import type { ColumnSizingInfoState, ColumnSizingState, HeaderGroup } from "@tanstack/react-table";
import { cn } from "../../lib/utils";
import { FilterableHeaderCell } from "./FilterableHeaderCell";

export const FilterableHeaderRow = <TData,>({
	headerGroups,
	setColumnSizing,
	columnSizing,
	columnSizingInfo,
	className,
}: {
	headerGroups: HeaderGroup<TData>[];
	setColumnSizing: (columnSizing: ColumnSizingState) => void;
	columnSizing: ColumnSizingState;
	columnSizingInfo: ColumnSizingInfoState;
	className?: string;
}) => (
	<div
		className={cn(
			"sticky z-20 top-0 left-0 right-0 h-[33px] flex w-full min-w-0 bg-gray-100 border-b border-gray-200 select-none",
			className,
		)}
	>
		{headerGroups.map((headerGroup) =>
			headerGroup.headers.map((header) => (
				<FilterableHeaderCell
					key={header.id}
					header={header}
					columnSizingInfo={columnSizingInfo}
					columnSizing={columnSizing[header.id]}
					setColumnSizing={(newColumnSize) =>
						setColumnSizing({ ...columnSizing, [header.id]: newColumnSize })
					}
				/>
			)),
		)}
	</div>
);
